import {
  ContainerChartTemplateDetails,
  ContainerEditChartTemplateDetails
} from 'containers/Dashboard/MachineDetail/GraphsTemplates/ChartTemplateDetails';
import React from 'react';
import { ROLE_MANAGER } from './roles';
import Account from '../containers/Account';
import ResetPassword from '../containers/Account/ResetPassword';
import Dashboard from '../containers/Dashboard';
import Machines from '../containers/Machines';
import MachinesDetail from '../containers/Machines/MachinesDetail';
import BatchRecords from '../containers/BatchRecords';
import BatchRecordsDetail from '../containers/BatchRecords/BatchRecordsDetail';
import UserManagement from '../containers/UserManagement';
import MachineDetail from '../containers/Dashboard/MachineDetail';
import AlreadyLoggedIn from '../containers/Auth/AlreadyLoggedIn';
import MachineHistory from '../containers/Dashboard/MachineDetail/MachineHistory';
import SensorHistory from '../containers/Dashboard/MachineDetail/SensorHistory';
import SensorComparison from '../containers/Dashboard/MachineDetail/SensorComparison';
import { ROUTE_BATCH_RECORDS, ROUTE_MACHINES } from './routePaths';

const externalAuthPath = '/login/:tokenHeader/:tokenPayload/:tokenSignature/'.concat(
  ':refreshTokenHeader/:refreshTokenPayload/:refreshTokenSignature'
);

// Save the current path to sessionStorage
// we need that to redirect the use when they try to access a route without being authenticated
const withRedirect = Component => props => {
  sessionStorage.setItem('redirect_after_login', window.location.pathname);
  return <Component {...props} />;
};

const ROUTES = [
  {
    path: '/dashboard',
    component: withRedirect(Dashboard),
    name: 'dashboard',
    topNav: false,
    subNav: { main: true },
    dataTestId: 'menu-selection-dashboard-button'
  },
  {
    path: `/${ROUTE_BATCH_RECORDS}`,
    component: withRedirect(BatchRecords),
    name: ROUTE_BATCH_RECORDS,
    allow_feature: 'BATCH_RECORDS',
    subNav: { main: true },
    dataTestId: 'menu-selection-batch-records-button'
  },
  {
    path: `/${ROUTE_BATCH_RECORDS}/:id`,
    component: withRedirect(BatchRecordsDetail),
    name: `${ROUTE_BATCH_RECORDS}-details`,
    allow_feature: 'BATCH_RECORDS'
  },
  {
    path: '/dashboard/:id',
    component: withRedirect(MachineDetail),
    name: 'machine'
  },
  {
    path: '/dashboard/:id/sensors',
    component: withRedirect(MachineDetail),
    name: 'machine'
  },
  {
    path: '/dashboard/:id/graph-templates',
    component: withRedirect(MachineDetail),
    name: 'machine'
  },
  {
    path: '/dashboard/:id/metrics',
    component: withRedirect(MachineDetail),
    name: 'machine'
  },
  {
    path: '/dashboard/:id/alarms',
    component: withRedirect(MachineDetail),
    name: 'machine'
  },
  {
    path: '/dashboard/:id/alerts',
    component: withRedirect(MachineDetail),
    name: 'machine'
  },
  {
    path: '/dashboard/:id/graph-templates/:templateId',
    component: withRedirect(ContainerChartTemplateDetails),
    name: 'chart-template-details'
  },
  {
    path: '/dashboard/:id/graph-templates/:templateId/edit',
    component: withRedirect(ContainerEditChartTemplateDetails),
    name: 'chart-template-details-edit'
  },
  {
    path: '/dashboard/:id/history',
    component: withRedirect(MachineHistory),
    name: 'machineHistory'
  },
  {
    path: '/dashboard/:id/sensor/compare',
    component: withRedirect(SensorComparison),
    name: 'machineSensorComparison'
  },
  {
    path: '/dashboard/:id/sensor/:sensorType',
    component: withRedirect(SensorHistory),
    name: 'machineSensorHistory'
  },
  {
    path: `/${ROUTE_MACHINES}`,
    component: withRedirect(Machines),
    name: ROUTE_MACHINES,
    topNav: false,
    subNav: { main: true },
    roles: [ROLE_MANAGER],
    dataTestId: 'menu-selection-machines-button'
  },
  {
    path: `/${ROUTE_MACHINES}/:id`,
    component: withRedirect(MachinesDetail),
    name: 'machines-detail',
    roles: [ROLE_MANAGER]
  },
  {
    path: '/user-management',
    component: withRedirect(UserManagement),
    name: 'user-management',
    subNav: { main: false },
    roles: [ROLE_MANAGER],
    dataTestId: 'menu-selection-user-management-button'
  },
  {
    path: '/account',
    component: withRedirect(Account),
    name: 'account',
    subNav: { main: false },
    dataTestId: 'menu-selection-user-account-button'
  },
  {
    path: '/account/reset-password',
    component: withRedirect(ResetPassword),
    name: 'reset_password'
  },
  {
    path: '/register/:token',
    component: AlreadyLoggedIn,
    name: 'already_logged_in'
  }
];

export { externalAuthPath };

export default ROUTES;
